import { StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppButton } from './AppButton';
import { AppText } from './AppText';

type ErrorViewProps = {
  title?: string;
  message: string;
  retryLabel?: string;
  onRetry?: () => void;
};

export function ErrorView({
  title = '请求失败',
  message,
  retryLabel = '重试',
  onRetry,
}: ErrorViewProps) {
  return (
    <View style={styles.container}>
      <AppText variant="subtitle" weight="semibold" tone="danger" align="center">
        {title}
      </AppText>
      <AppText tone="muted" align="center" style={styles.message}>
        {message}
      </AppText>
      {onRetry ? <AppButton label={retryLabel} onPress={onRetry} style={styles.action} /> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacing.xxl,
  },
  message: {
    marginTop: tokens.spacing.sm,
  },
  action: {
    marginTop: tokens.spacing.lg,
  },
});
